<template>
    <div class="quesSheetDialog">
        <el-dialog title="答卷" :visible.sync="dialogVisible" width="970px" @close="cancel">
            <div class="filters">
                <div class="add flexstart">
                    <el-button type="primary" @click="handleExport">导出</el-button>
                </div>
                <div class="search">
                    <el-date-picker v-model="timeSlot" type="daterange" value-format="yyyy-MM-dd" range-separator="-"
                                    class="condition" :picker-options="pickerDateFront"
                                    start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
                    <el-input v-model="param.customername" placeholder="请输入参与人" class="condition" clearable></el-input>
                    <el-button type="primary" plain @click="handleQuery">搜索</el-button>
                </div>
            </div>
            <div class="container">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="custmername" label="参与人" class-name="tc" label-class-name="tc" min-width="160px">
                        <template slot-scope="scope">
                            <div class="imageText">
                                <img class="img" v-lazy="scope.row.headerurl" :alt="scope.row.custmername"
                                     preview="bbOrderList">
                                <div class="text-ellipses" style="flex-grow: 1"><div class="text">{{scope.row.custmername}}</div></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="datetime" label="完成时间" class-name="tc" label-class-name="tc" min-width="160px"></el-table-column>
                    <el-table-column prop="" :label="obj.colname" class-name="tc" label-class-name="tc" v-for="(obj,idx) in collist" :key="idx" min-width="150px">
                        <template slot-scope="scope">{{scope.row.colvaluelist[idx].colvalue}}</template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                           :page-size="page.pageSize"
                           :pager-count="11" layout="prev, pager, next" :total="total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {exportCommonUserFormList, getCommonUserFormList} from 'api/operateToolApi'
    import {dateFormat} from 'common/js/tools'

    export default {
        name: 'quesSheetDialog',
        data() {
            return {
                dialogVisible: false,
                tableData: [],
                collist: [],
                page: {
                    page: 1,
                    pageSize: 10,
                    pageCount: 0
                },
                total: 0,
                timeSlot: null,
                param: {
                    begintime: '',
                    endtime: '',
                    customername: '',
                    innerid: ''
                },
                pickerDateFront: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()
                    },
                    onPick({maxDate, minDate}) {
                        if (maxDate) {
                            if (maxDate - minDate > 30 * 24 * 60 * 60 * 1000) {
                                this.$message.error('时长不能超过30天，请重新选择')
                            }
                        }
                    }
                },
            }
        },
        mounted() {
        },
        methods: {
            handleQuery() {
                if (this.timeSlot) {
                    let beginDate = new Date(this.timeSlot[0])
                    let endDate = new Date(this.timeSlot[1])
                    if (endDate - beginDate > 30 * 24 * 60 * 60 * 1000) {
                        this.$message.error('时长不能超过30天，请重新选择')
                        return false
                    }
                    this.param.begintime = this.timeSlot[0]
                    this.param.endtime = this.timeSlot[1]
                } else {
                    this.param.begintime = ''
                    this.param.endtime = ''
                }
                this.page.page = 1
                this._getList()
            },
            handleExport() {
                this.setLoading(true)
                exportCommonUserFormList({
                    data: this.param,
                    success: data => {
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '答卷' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            cancel() {
                this.dialogVisible = false
            },
            openDialog(row) {
                this.param.innerid = row.innerid
                this.tableData = []
                this._getList()
                this.dialogVisible = true
            },
            _getList() {
                this.setLoading(true)
                getCommonUserFormList({
                    data: Object.assign({}, this.param, this.page),
                    success: data => {
                        this.tableData = data.data.content
                        if (this.page.page == 1) this.collist = data.data.collist
                        this.total = data.data.pageinfo.rowCount
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions(['setLoading'])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .quesSheetDialog {
        .imageText{
            .img{
                width: 40px !important;
                height: 40px !important;
                min-width: 40px !important;
            }
        }
        .tc {
            .cell {
                text-align: center;
                white-space:nowrap;
            }
        }
        .el-input, .el-input input {
            width: 240px;
            height: 32px;
            line-height: 32px;
        }
        .el-button {
            margin-bottom: 0;
        }
        .el-date-editor {
            width: 240px;
            input {
                width: 100px;
            }
        }
        .container{
            width: 100%;
            overflow-x: auto;
        }
        .el-table{
            max-width: none;
            min-width: 100%
        }
    }
</style>
